<div class="XFGT">
  <div style="display: block;">
    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
      [plugins]="barChartPlugins" [legend]="barChartLegend" [chartType]="barChartType">
    </canvas>
  </div>
</div>